import React, { useEffect, useRef, useState } from "react";
import { Header } from "homepage/homeHeader";
import { HomeFooter } from "homepage/homeFooter";
import { Formik, ErrorMessage, Form, Field } from "formik";
import * as Yup from "yup";
import {
  LoadCanvasTemplateNoReload,
  loadCaptchaEnginge,
  validateCaptcha,
} from "react-simple-captcha";
import { useToaster } from "hooks";
import api from "services/api";
import ContactUsForm from "components/contactUsForm";

const initialValues = {
  name: "",
  phone_no: "",
  org_name: "",
  email: "",
  subject: "",
  call_back: "",
  description: "",
  attach_file: "",
  enquiry_type: "",
  // captcha: "", // Add this line
};

const validationSchema = Yup.object({
  name: Yup.string()
    .required("Required")
    .min(3, "Name must be at least 3 characters")
    .matches(/^[a-zA-Z ]*$/, "Name can only contain letters and spaces"),
  phone_no: Yup.string()
    .matches(/^[0-9]{10}$/, "Phone number must be 10 digits")
    .required("Required"),
  org_name: Yup.string().min(
    3,
    "Organization Name must be at least 3 characters"
  ),
  email: Yup.string()
    .email("Invalid email format")
    .matches(
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      "Invalid email format"
    )
    .required("Required"),
  subject: Yup.string().required("Required"),
  enquiry_type: Yup.string().required("Required"),
  description: Yup.string().required("Required"),
  call_back: Yup.string().required("Required"),
  // attach_file: Yup.mixed(),
  // captcha: Yup.string().required("CAPTCHA is required"), // Add this line
});
export const ContactUs = () => {
  return (
    <>
      {/* <div className="home-page"> */}
      <Header />
      <section>
        <div className="container network-block mt-3">
          <div className="row">
            <div className="col-md-12 mb-5">
              <div className="network-content">
                <div className="text-center mb-3 pb-1">
                  <span
                    className="badge bg-label-primary"
                    style={{ padding: "0.6rem 1.2rem", fontSize: "1rem" }}
                  >
                    Contact Us
                  </span>
                </div>

                <ContactUsForm />
              </div>
            </div>
          </div>
        </div>
      </section>
      <HomeFooter />
      {/* </div> */}
    </>
  );
};
